import useWidth from './useWidth';

const useCols = () => {
  const width = useWidth();
  switch (width) {
    case 'xs':
      return 1;
    case 'sm':
      return 2;
    default:
      return 3;
  }
};

export const useResponsiveCols = (def, config) => {
  const width = useWidth();
  return config[width] || def;
};

export default useCols;
